import { createSvgIcon } from '@mui/material';

const IconCoo2Fre = createSvgIcon(
  <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 50 50">
    <g id="Group_10686" data-name="Group 10686" transform="translate(-504 -2253)">
      <rect
        id="Rectangle_5274"
        data-name="Rectangle 5274"
        width="50"
        height="50"
        rx="25"
        transform="translate(504 2253)"
        fill="#f7f8f8"
      />
      <g id="Group_6806" data-name="Group 6806" transform="translate(-611.014 -2386.887)">
        <g id="Group_6395" data-name="Group 6395" transform="translate(1124.446 4658.309)">
          <g id="Group_6413" data-name="Group 6413" transform="translate(0 0)">
            <path
              id="Path_3430"
              data-name="Path 3430"
              d="M181,48.714c2.411-5.092,6.18-8.4,12.283-8.927"
              transform="translate(-180.997 -31.682)"
              fill="none"
              stroke="#85C440"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1.5"
            />
            <path
              id="Path_3431"
              data-name="Path 3431"
              d="M187.745,42.248c7.313,2.518,13.682.385,17.8-9.663l.809-2.35-4.715-1.623c-10.589-3.646-15.721-.15-17.763,5.725a8.042,8.042,0,0,0,.328,6.691l3.528,1.215Z"
              transform="translate(-181.825 -27.124)"
              fill="none"
              stroke="#85C440"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1.5"
            />
          </g>
        </g>
        <g id="logo-99minutos.6ca31ef5" transform="translate(1118.856 4643.521)">
          <path
            id="Fill-14"
            d="M155.327,94.856l3.239-3.239s-2.09-5.329-9.612-9.717l-3.239,3.239,3.761,3.761-.836.836a19.639,19.639,0,0,0-32.389,15.045A19.643,19.643,0,1,0,150.835,91.93l.836-.836Zm-4.075,9.612A15.412,15.412,0,1,1,135.894,88.9a15.518,15.518,0,0,1,15.359,15.568Z"
            transform="translate(-116.251 -81.9)"
            fill="#85C440"
          />
        </g>
      </g>
    </g>
  </svg>,
  'IconCoo2Fre',
);

export default IconCoo2Fre;
